/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: LinkDynamicDialog.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/26 @ 1751
 * ---
 * Description:
 */

import { observer }                        from 'mobx-react';
import classNames                          from 'classnames';
import { currentThemeIsDark }              from '../../../../common/utils';
import { Button, Classes, Dialog, Intent } from '@blueprintjs/core';
import {
  LinkDynamicPanel
}                                          from '../../selection-tabs/dataorigins/LinkDynamicPanel';
import { useState }                        from 'react';
import { IDataRef }                        from '@revodigital/mpes';
import { BaseDialogProps, HasEditor }      from '../../../../common/props';

interface Props extends HasEditor, BaseDialogProps {
  onLink: (dataRef: IDataRef) => void;
}

export const LinkDynamicDialog = observer((props: Props) => {
  const [dataRef, setDataRef] = useState<IDataRef>();

  return (
    <Dialog
      usePortal
      className={ classNames({ 'bp4-dark': currentThemeIsDark() }) }
      style={ { width: '35rem', height: '25rem' } }
      isOpen={ props.isOpen }
      title="Collega campo dinamico"
      onClose={ props.onClose }
      canOutsideClickClose={ false }
    >
      <div className={ Classes.DIALOG_BODY }>
        <LinkDynamicPanel editor={ props.editor }
                          onDataOriginChange={ (dataRef) => {
                            setDataRef(dataRef);
                          } }/>
        <div className="flex flex-row my-5 space-x-3 h-8">
          {
            dataRef &&
            <Button onClick={ () => {
              props.onLink(dataRef);
              props.onClose();
            } } intent={ Intent.PRIMARY }>Collega
              '{ dataRef.name }'</Button>
          }
        </div>
      </div>
    </Dialog>
  );
});